import { Component, OnInit, Input } from '@angular/core';
import { AvailabilityService } from '../../../injections/availability.service';

@Component({
    moduleId: module.id,
    selector: 'main-availability',
    templateUrl: '../templates/main-availability.html',
    providers: [],
})

export class MainAvailabilityComponent implements OnInit {

   public availability: Array<object>;
   public districts: Array<object>;
    constructor(private availabilityService: AvailabilityService) {
        //console.log("MainuserComponent");
     }
    ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/modules/availability/components/main-availability.component.ts